/**
 * Dépendances globales
 */
import $ from "jquery";
window.$ = window.jQuery = $;

import Popper from "popper.js";
window.Popper = Popper;

/**
 * Bootstrap 4 JS
 */
import "bootstrap/dist/js/bootstrap.bundle";

/**
 * Scripts du projet (remplacement des require)
 */
import "./HeaderSticky";
import "./FooterSticky";
import "./BackToTop";
import "./MenuItemActive";
import "./TitreCategoriesCard";
import "./AccordionCategories";
import "./ResponsiveFilterCat";
import "./FilAriane";
import "./mask";

/**
 * Tooltips Bootstrap
 */
$(function () {
  $('input[rel="txtTooltip"]').tooltip();
  $('[data-toggle="tooltip"]').tooltip();
});

/**
 * Basedoc
 */
$(".basedoc .input-search input").on("input", function () {
  if ($(this).val() !== "") {
    $(".basedoc .input-search button").hide();
  } else {
    $(".basedoc .input-search button").show();
  }
});

//Suivre dossier timeline
if ($("#timeline.declaration")) {
  if ($(window).width() < 768) {
    $("#timeline.declaration").removeClass("horizontal");
    $("#timeline.declaration").addClass("vertical");
  } else {
    $("#timeline.declaration").removeClass("vertical");
    $("#timeline.declaration").addClass("horizontal");
  }
}

//Show dossier Blocs droites
//--Si on clique sur "Transmettre nouvelles pieces"
$("#linktransmettrepieces").click(function (event) {
  event.preventDefault();
  if ($(window).width() < 768) {
    $("#contact .card-header a").click();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("#contact .card-header a").offset().top - 150,
      },
      1000
    );
    $("#objetdemande option").removeAttr("selected");
    $("#objetdemande option[value=demenvoipieces]").attr(
      "selected",
      "selected"
    );
  } else {
    $("#tab-F").click();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("#tab-F").offset().top - 150,
      },
      1000
    );
    $("#objetdemande option").removeAttr("selected");
    $("#objetdemande option[value=demenvoipieces]").attr(
      "selected",
      "selected"
    );
  }
});
//--Si on clique sur "Prendre rdv"
$("#linkrdvgestionnaire").click(function (event) {
  event.preventDefault();
  if ($(window).width() < 768) {
    $("#contact .card-header a").click();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("#contact .card-header a").offset().top - 150,
      },
      1000
    );
    $("#objetdemande option").removeAttr("selected");
    $("#objetdemande option[value=demcontactgest]").attr(
      "selected",
      "selected"
    );
  } else {
    $("#tab-F").click();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("#tab-F").offset().top - 150,
      },
      1000
    );
    $("#objetdemande option").removeAttr("selected");
    $("#objetdemande option[value=demcontactgest]").attr(
      "selected",
      "selected"
    );
  }
});
//--Si on clique sur "Signaler une erreur"
$(".linksignalerror").click(function (event) {
  event.preventDefault();
  if ($(window).width() < 768) {
    $("#contact .card-header a").click();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("#contact .card-header a").offset().top - 150,
      },
      1000
    );
    $("#objetdemande option").removeAttr("selected");
    $("#objetdemande option[value=demmodif]").attr("selected", "selected");
  } else {
    $("#tab-F").click();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("#tab-F").offset().top - 150,
      },
      1000
    );
    $("#objetdemande option").removeAttr("selected");
    $("#objetdemande option[value=demmodif]").attr("selected", "selected");
  }
});
